import React from 'react';
import UserFilter from './UserFilter';
import UserTable from './UserTable';
import { Card, Row, Col } from 'antd';

export default function UserSalesReport() {
    
    return (
        <Card className="report-table">
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <UserFilter />
                </Col>
                <Col span={24}>
                    <UserTable />
                </Col>
            </Row>
        </Card>
    )
}
